import React from 'react';
import styles from './PrintPetInfo.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeartbeat } from '@fortawesome/pro-light-svg-icons';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import PetAvatar from 'components/Bookings2/UI/PetAvatar/PetAvatar';
import { PetType } from '@spike/model';

interface Props {
    petName: string;
    petBreed: string;
    petType: PetType;
    hasMedicalConditions?: boolean;
    hasNegativeTags?: boolean;
}

export const PrintPetInfo: React.FC<Props> = ({
    petName,
    petBreed,
    petType,
    hasMedicalConditions,
    hasNegativeTags
}) => {
    return (
        <div className={styles.container}>
            <PetAvatar
                petType={petType}
                className={styles.avatar}
                iconClassName={styles.avatarIcon}
            />

            <div className={styles.details}>
                <div className={styles.row}>
                    <span className={styles.name}>{petName}</span>

                    {hasMedicalConditions && (
                        <FontAwesomeIcon
                            icon={faHeartbeat}
                            className={styles.medicalIcon}
                        />
                    )}

                    {hasNegativeTags && (
                        <FontAwesomeIcon
                            icon={faTriangleExclamation}
                            className={styles.behaviorIcon}
                        />
                    )}
                </div>

                <div className={styles.breed}>{petBreed}</div>
            </div>
        </div>
    );
};

export default PrintPetInfo;
